<template>
  <div>
    <NuxtLayout name="split">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.TRAVELER" />

      <template #aside>
        <UIcon
          name="EscapadaLogoSmall"
          class="w-12 h-12 mb-6 text-white"
          aria-hidden="true"
        />

        <ul>
          <li
            v-for="(item, index) in asideTexts"
            :key="index"
            class="flex gap-x-2"
          >
            <TTitle
              size="4xl"
              color="text-white"
              :bold="true"
              leading="tight"
              classes="m-0"
            >
              {{ item }}
            </TTitle>
          </li>
        </ul>
      </template>

      <AuthRegisterTraveler>
        <i18n-t
          keypath="auth.registrationTraveler.label"
          tag="span"
          scope="global"
        >
          <template #signUp>
            <ULink :active="true" :href="routes().login()" external>
              {{ t('auth.registrationTraveler.signUp') }}
            </ULink>
          </template>
        </i18n-t>
      </AuthRegisterTraveler>
      <SSpacer />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
// Constants
import { CONNECTIF_PAGE_TAGS } from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'

const { setHeadInfo } = useHeadInfoComposable()
const breadCrumbMenuStore = useMenuBreadcrumbStore()

breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.register-traveler'))

definePageMeta({
  layout: false,
  splitImageUrl: '/__nuxt-public/images/registration/split-side.jpeg',
  splitImageAlt: 'views.registration-traveler.pageMeta.splitImageAlt',
})

setHeadInfo({
  title: t('views.registration-traveler.seo.title'),
  description: t('views.registration-traveler.seo.description'),
  robotsVisible: true,
  images: [
    {
      url: '/__nuxt-public/images/registration/split-side.jpeg',
      alt: t('views.registration-traveler.seo.title'),
    },
  ],
})

const asideTexts: Array<string> = [
  t('views.registration-traveler.aside.text1'),
  t('views.registration-traveler.aside.text2'),
  t('views.registration-traveler.aside.text3'),
  t('views.registration-traveler.aside.text4'),
]

sendConnectifPage()
</script>
